// jshint esversion: 8
import dateToPython from '@/utils/dateToPython';

export default {
  all: state => state.data,
  byId: state => id => state.data.find(item => item.id === id),
  byDate: state => d => state.data.find( item => item.date === dateToPython(d))
};
